module.exports = __webpack_public_path__ + "img/icon_claim_address.acfdd943.png";